import { render } from "./AIAgentTraining.vue?vue&type=template&id=45db3fa0&scoped=true"
import script from "./AIAgentTraining.vue?vue&type=script&lang=js"
export * from "./AIAgentTraining.vue?vue&type=script&lang=js"

import "./AIAgentTraining.vue?vue&type=style&index=0&id=45db3fa0&scoped=true&lang=scss"
import "./AIAgentTraining.vue?vue&type=style&index=1&id=45db3fa0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45db3fa0"]])

export default __exports__